import Vue from 'vue'
import Sortable from 'sortablejs'

const emit = (vnode, name, data) => {
  const handlers = (vnode.data && vnode.data.on) ||
    (vnode.componentOptions && vnode.componentOptions.listeners)

  if (handlers && handlers[name]) {
    handlers[name].fns(data)
  }
}

const createSortable = (el, options, vnode) => {
  return Sortable.create(el, {
    ...options,
    onEnd (evt) {
      emit(vnode, 'drag-end', evt)
    }
  })
}

Vue.directive('sortable', {
  name: 'sortable',
  bind (el, binding, vnode) {
    let elem = el.querySelector('tbody')
    if (!elem) {
      elem = el
    }
    el._sortable = createSortable(elem, binding.value, vnode)
  },
  update (el, binding, vnode) {
    let elem = el.querySelector('tbody')
    if (!elem) {
      elem = el
    }
    el._sortable.destroy()
    el._sortable = createSortable(elem, binding.value, vnode)
  },
  unbind (el) {
    el._sortable.destroy()
  }
})
